import { exportActivities } from './index';
import { getExams, addExam } from '../exams';

const exportExams = data => {
    return exportActivities({ ...data, getter: getExams, adder: addExam, dateField: 'startDateTime' });
};

export default exportExams;
